import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';

/**
 * Bouton conditionnel basé sur les permissions
 */
const ConditionalButton = ({ 
  entity, 
  permission, 
  children, 
  className = '', 
  onClick, 
  disabled = false,
  ...props 
}) => {
  const { canCreate, canUpdate, canDelete, canRead, canManage } = usePermissions();

  // Détermine quelle fonction de permission utiliser
  const getPermissionCheck = () => {
    switch (permission) {
      case 'create':
        return canCreate(entity);
      case 'update':
        return canUpdate(entity);
      case 'delete':
        return canDelete(entity);
      case 'read':
        return canRead(entity);
      case 'manage':
        return canManage(entity);
      default:
        return true;
    }
  };

  const hasPermission = getPermissionCheck();

  // Si l'utilisateur n'a pas la permission, ne pas rendre le bouton
  if (!hasPermission) {
    return null;
  }

  return (
    <button
      className={className}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default ConditionalButton;
